import { render } from "./DeleteSong.vue?vue&type=template&id=370d14af&scoped=true"
import script from "./DeleteSong.vue?vue&type=script&lang=js"
export * from "./DeleteSong.vue?vue&type=script&lang=js"

import "./DeleteSong.vue?vue&type=style&index=0&id=370d14af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-370d14af"

export default script